<template>
  <v-card
    elevation="4"
    class="my-3"
  >
    <v-container fluid>
      <div class="text-h3">
        Trip Incidents Summary
      </div>
      <div class="mt-2">
        <v-data-table
          :headers="_headers"
          :items="list"
          hide-default-footer
        >
          // eslint-disable-next-line
          <template v-slot:item.severity="{ item }">
            <status-badge
              :status="item.severity"
              :text="item.severity"
            />
          </template>
          // eslint-disable-next-line
          <template v-slot:item.actions="{ item }">
            <div>
              <v-btn
                color="primary"
                small
                @click="openModal(item)"
              >
                <v-icon>mdi-video-account</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <modal
      :is-visible="isModal"
      is-view
      width="800px"
      :title="`Incident Video - ${selectedRow.incident_type}`"
      :sub-title="`Vehicle ID: ${selectedRow.vehicle_id} | Time: ${selectedRow.timestamp} `"
      :toggle="openModal"
    >
      <div>
        <video
          v-if="
            ['Over Speeding', 'Harsh Braking'].includes(
              selectedRow.incident_type
            )
          "
          width="100%"
          height="100%"
          controls
          src="@/assets/dummy/overspeeding.mp4"
        />
        <video
          v-if="['Near Miss'].includes(selectedRow.incident_type)"
          width="100%"
          height="100%"
          controls
          src="@/assets/dummy/near-miss.mp4"
        />
      </div>
    </modal>
  </v-card>
</template>
<script>
export default {
  components: {
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
    Modal: () => import("@/components/Modals/Modal.vue"),
  },
  data() {
    return {
      selectedRow: {},
      isModal: false,
      headers: [
        {
          text: this.$t("incident_type"),
          align: "left",
          sortable: true,
          value: "incident_type",
        },
        {
          text: this.$t("vehicle_id"),
          align: "left",
          sortable: true,
          value: "vehicle_id",
        },
        {
          text: this.$t("timestamp"),
          align: "left",
          sortable: true,
          value: "timestamp",
        },
        {
          text: this.$t("severity"),
          align: "left",
          sortable: true,
          value: "severity",
        },
        {
          text: this.$t("actions"),
          align: "left",
          sortable: false,
          value: "actions",
        },
      ],
      list: [
        {
          incident_type: "Over Speeding",
          vehicle_id: "10346",
          timestamp: "27-04-2025 06:32:45 PM",
          severity: "High",
          src: `@/assets/dummy/near-miss.mp4`,
          actions: "View",
        },
        {
          incident_type: "Harsh Braking",
          vehicle_id: "1034G",
          timestamp: "27-04-2025 07:15:22 PM",
          severity: "Medium",
          src: `@/assets/dummy/near-miss.mp4`,
          actions: "View",
        },
        {
          incident_type: "Near Miss",
          vehicle_id: "10346",
          timestamp: "27-04-2025 07:58:10 PM",
          severity: "High",
          src: `@/assets/dummy/near-miss.mp4`,
          actions: "View",
        },
        // {
        //   incident_type: "Over Speeding",
        //   vehicle_id: "10346",
        //   timestamp: "27-04-2025 08:22:33 PM",
        //   severity: "Medium",
        //   actions: "View",
        // },
      ],
    };
  },
  computed: {
    _headers() {
      // computed headers for showing columns to role based
      return this.headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },
  },
  methods: {
    openModal(v) {
      if (v) {
        this.selectedRow = v;
        this.isModal = true;
      } else {
        this.selectedRow = {};
        this.isModal = false;
      }
    },
  },
};
</script>
